import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { DeclarationsApiResponse } from './types'

import { AxiosError } from 'axios'
import apiClient from '../../services/api-client'
import { RootState } from '../../store/rootReducer'
import storage from 'redux-persist/lib/storage'

export const getDeclarations = createAsyncThunk<DeclarationsApiResponse, void>(
  'declarations/getDeclarations',
  async () => {
    const response = await apiClient.get<DeclarationsApiResponse, AxiosError>('/declarations')
    return response.data
  },
)

export interface DeclarationsState {
  data: DeclarationsApiResponse | null
  status: 'idle' | 'pending' | 'fulfilled' | 'rejected'
  error: AxiosError | null
}

const initialState: DeclarationsState = {
  data: null,
  status: 'idle',
  error: null,
}

export const declarationsPersistConfig = {
  key: 'declarations',
  storage: storage,
  blacklist: ['status', 'error'],
}

const DeclarationsSlice = createSlice({
  name: 'declarations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDeclarations.pending, (state) => {
        state.status = 'pending'
        state.error = null
      })
      .addCase(getDeclarations.fulfilled, (state, action) => {
        state.status = 'fulfilled'
        state.data = action.payload
      })
      .addCase(getDeclarations.rejected, (state, action) => {
        state.status = 'rejected'
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        state.error = action.error
      })
  },
})

export const selectDeclarations = (state: RootState) => state.declarations.data
export const selectDeclarationsStatus = (state: RootState) => state.declarations.status

export default DeclarationsSlice
